// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Demo talep formunu gönder
 */
export const submitDemoTalep = async (formData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/demo-talep`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        ad_soyad: formData.name,
        email: formData.email,
        telefon: formData.phone || null,
        sirket_adi: formData.company || null,
        mesaj: formData.message,
        demo_talep: true,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Bir hata oluştu');
    }

    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

